import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import CommonDataTable from '../../common/DataTable';
import { getUserColumns } from '../../Components/Common/columns/Users';
import { bulkDeleteUser, deleteUser, getUserWithFilter } from '../../slices/thunks';

const UsersList = () => {
  const dispatch = useDispatch();
  const { users = { data: [], count: 0 }, loading, filterParams } = useSelector((state) => state.user || {});

  const [selectedRows, setSelectedRows] = useState([]);
  const [confirmOpenForId, setConfirmOpenForId] = useState(null);

  useEffect(() => {
    dispatch(getUserWithFilter(filterParams));
  }, [dispatch, filterParams]);

  const handleDelete = useCallback(async (event, userId) => {
    event.preventDefault();
    try {
      await dispatch(deleteUser(userId));
      dispatch(getUserWithFilter(filterParams));
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  }, [dispatch, filterParams]);

  const handleBulkDelete = useCallback(async () => {
    const userIds = selectedRows.map((row) => row.id);
    if (userIds.length > 0) {
      try {
        await dispatch(bulkDeleteUser({ userIds }));
        dispatch(getUserWithFilter(filterParams));
        setSelectedRows([]);
      } catch (error) {
        console.error('Error in bulk delete:', error);
      }
    }
  }, [dispatch, selectedRows, filterParams]);


  const fetchData = useCallback((filterParams) => {
    dispatch(getUserWithFilter(filterParams));
  }, [dispatch]);

  const columns = getUserColumns({
    onDeleteClick: handleDelete,
    confirmOpenForId,
    setConfirmOpenForId,
  });

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <BreadCrumb title='Users' pageTitle='Users' />
        </Container>
      </div>
      <div className='table-container'>
        <CommonDataTable
          from="user"
          data={users?.rows || []}
          totalRows={users?.count || 0}
          loading={loading}
          showAddButton={false}
          columns={columns}
          checkboxEnabled={true}
          bulkDelete={handleBulkDelete}
          selectedRows={selectedRows}
          bulkSelected={(rows) => setSelectedRows(rows)}
          searchEnable={true}
          filterParams={filterParams}
          fetchData={fetchData}
          showExportButton={true}
          exportFileName="Users"
        />
      </div>
    </React.Fragment>
  );
};

export default UsersList;
